export default __webpack_public_path__ + "static/media/chevronRight.20e8a2d4.svg";